import {isNil} from 'ramda';

import {Equipment} from '../types/Equipment';

const BE_NULL_DESCRIPTION_PLACEHOLDER = '-';

export const isNullishDescription = (item: NonNullable<Equipment>) =>
  isNil(item?.description) || item.description === BE_NULL_DESCRIPTION_PLACEHOLDER;
